import { call, put, takeLatest } from 'redux-saga/effects';
import { FETCH_LOCALITIES_BY_RADIUS, fetchLocalitiesRadiusSuccess, fetchLocalitiesRadiusFailure, fetchLocalitiesRadiusStart } from '../actions/radiusActions';
import {clientAPI} from '../../utils/axiosInstance';

function* fetchLocalitiesRadiusSaga(action) {
  const { pincode, locality } = action.payload;
  console.log(action.payload);
  try {
    yield put(fetchLocalitiesRadiusStart());
    const radiusValues = [1000, 2000, 3000, 4000, 5000];
    const radiusData = {};

    for (let radius of radiusValues) {
      const response = yield call(clientAPI.post, '/nearbySearch', {
        pincode,
        locality,
        radius
      });
      if (response.data.status === 'SUCCESS') {
        radiusData[radius / 1000] = response.data.data.localities;
      }
    }
    console.log(radiusData);
    yield put(fetchLocalitiesRadiusSuccess(radiusData));
  } catch (error) {
    yield put(fetchLocalitiesRadiusFailure(error.message));
  }
}

export default function* watchFetchLocalitiesRadius() {
  yield takeLatest(FETCH_LOCALITIES_BY_RADIUS, fetchLocalitiesRadiusSaga);
}